import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { PRIMARY_EVENT_COLOR } from '../../../constants';

export const AppointmentCardColorPreview = ({ color }: { color: string }) => {
  const { t } = useTranslation('scheduleAppointmentTypes');

  return (
    <div
      css={{
        backgroundColor: theme.colors.neutral5,
        padding: theme.spacing(1),
        marginTop: theme.spacing(1),
        borderRadius: theme.borderRadius.small,
      }}
    >
      <Text color='subdued'>{t('Preview')}</Text>
      <div
        css={{
          width: '100%',
          minHeight: 40,
          borderRadius: theme.borderRadius.small,
          backgroundColor: theme.colors.white,
          borderLeft: `${theme.spacing(1)} solid ${color || PRIMARY_EVENT_COLOR}`,
          padding: theme.spacing(1),
          marginTop: theme.spacing(1),
        }}
      >
        <Text weight='bold'>{t('Patient Name')}</Text>
        <Text color='light'>{t('10.30 AM - 11.00 AM')}</Text>
      </div>
    </div>
  );
};
